module.exports = __webpack_public_path__ + "img/chinesecompany88.73db8730.png";